import axios from "axios";
import { Toast } from "vant";

console.log("process.env.NODE_ENV", process.env);
const request = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

request.defaults.crossDomain = true;
request.defaults.withCredentials = true; //让ajax携带cookie

request.interceptors.request.use(
  (config) => {
    if (config.method === "post") {
      config.data = config.data || {};
    }
    console.log("config", config.data);
    return config;
  },
  (error) => {
    return Promise.reject();
  }
);

request.interceptors.response.use(
  (response) => {
    //接收到响应数据并成功后的一些共有的处理
    if (response.data.success) {
      return response.data.payload;
    } else {
      if (!response.config.isMassage) {
        Toast({
          message: response.data.error,
          icon: "cross",
        });
      }
      return Promise.reject(response.data);
    }
  },
  (error) => {
    Toast({
      message: error.response.data.error,
      icon: "cross",
      duration: 2 * 1000,
    });
    return Promise.reject(error.response);
  }
);

export default request;
